/*
  PDP enhancements (Pause Rituals):
  1. Smooth accordion open/close for the Description tabs (native <details> can't animate).
  2. Instant variant -> main-image swap (no waiting for the AJAX variant fetch, no reorder).
*/
(function () {
  var EASE_MS = 340;

  /* -------------------------------------------------- smooth accordion ---- */
  function setupAccordion(details) {
    if (details.dataset.accReady === '1') return;
    var summary = details.querySelector('summary');
    var body = details.querySelector('.pdp-acc__body');
    if (!summary || !body) return;
    details.dataset.accReady = '1';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.dataset.animating === '1') return;
      details.dataset.animating = '1';

      if (details.open) {
        // collapse: animate current height -> 0, then drop `open`
        var start = body.scrollHeight;
        body.style.height = start + 'px';
        void body.offsetHeight;
        requestAnimationFrame(function () {
          body.style.height = '0px';
        });
        var onClose = function (ev) {
          if (ev && ev.propertyName !== 'height') return;
          body.removeEventListener('transitionend', onClose);
          clearTimeout(fb);
          details.open = false;
          body.style.height = '';
          details.dataset.animating = '';
        };
        body.addEventListener('transitionend', onClose);
        var fb = setTimeout(onClose, EASE_MS + 80);
      } else {
        // expand: open natively (height auto), then animate 0 -> content height
        details.open = true;
        var target = body.scrollHeight;
        body.style.height = '0px';
        void body.offsetHeight;
        requestAnimationFrame(function () {
          body.style.height = target + 'px';
        });
        var onOpen = function (ev) {
          if (ev && ev.propertyName !== 'height') return;
          body.removeEventListener('transitionend', onOpen);
          clearTimeout(fo);
          body.style.height = '';
          details.dataset.animating = '';
        };
        body.addEventListener('transitionend', onOpen);
        var fo = setTimeout(onOpen, EASE_MS + 80);
      }
    });
  }

  /* ---------------------------------------- instant variant -> image ---- */
  function setupMediaSync(productInfo) {
    if (productInfo.dataset.mediaSyncReady === '1') return;
    var mapEl = productInfo.querySelector('[data-variant-media]');
    if (!mapEl) return;
    var map;
    try { map = JSON.parse((mapEl.textContent || '').trim()); } catch (err) { return; }
    if (!map || !Object.keys(map).length) return;
    productInfo.dataset.mediaSyncReady = '1';

    // Attach the listener unconditionally — resolve the gallery + setActiveMedia
    // at click time (the <media-gallery> custom element may not be upgraded yet at load).
    productInfo.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      var gallery = productInfo.querySelector('media-gallery');
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

      var picker = t.closest('variant-selects') || productInfo;
      var checked = picker.querySelectorAll('input[type="radio"]:checked');
      var key = Array.prototype.map.call(checked, function (i) { return i.value; }).join(' / ');
      var mediaId = map[key] || map[t.value];
      if (mediaId) gallery.setActiveMedia(mediaId, false); // false = no reorder
    });
  }

  /* ----- keep the thumbnail border in sync with the active main image ----- */
  /* Single source of truth: the selected thumbnail is ALWAYS the one whose
     data-target matches the currently active main slide. Anything that changes the
     active slide — first paint, variant swap (instant map OR Dawn's AJAX fetch),
     thumbnail click, or mobile swipe — flows through here. Thumbnail ORDER is never
     touched; only the aria-current flag (which draws the ring) moves.

     Why a dedicated, authoritative sync instead of trusting Dawn:
       - Dawn moves aria-current only inside setActiveMedia() and on a debounced
         (500ms) slideChanged scroll event, with several early-returns. On a variant
         change Dawn also REORDERS the slide <li> nodes, which the previous observer
         (class-only, with an early-return) could miss — so the image updated but the
         ring didn't. We observe class AND childList, and re-assert on every trigger. */
  function setupThumbSync(gallery) {
    if (gallery.dataset.thumbSyncReady === '1') return;
    var viewer = gallery.querySelector('.product__media-list');
    var thumbs = gallery.querySelector('.thumbnail-list');
    if (!viewer || !thumbs) return; // single-image product: no thumbnails to sync
    gallery.dataset.thumbSyncReady = '1';

    function activeMediaId() {
      // The slide Dawn/instant-swap marked active; fall back to the first slide so a
      // thumbnail is ALWAYS selected on load even if no is-active was emitted.
      var active =
        viewer.querySelector('[data-media-id].is-active') || viewer.querySelector('[data-media-id]');
      return active ? active.getAttribute('data-media-id') : null;
    }

    function sync() {
      var id = activeMediaId();
      if (!id) return;
      var li = thumbs.querySelector('.thumbnail-list__item[data-target="' + id + '"]');
      if (!li) return;
      var target = li.querySelector('.thumbnail');
      if (!target) return;
      // ONE selection signal: aria-current. Clear it from every other thumbnail and set
      // it on the active one. The single inset ring in pdp-gallery.css renders purely
      // from this attribute, so there is exactly one selected style everywhere.
      thumbs.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) {
        if (b !== target) b.removeAttribute('aria-current');
      });
      if (target.getAttribute('aria-current') !== 'true') {
        target.setAttribute('aria-current', 'true');
      }
    }

    // Re-sync on active-slide changes (class toggle) AND slide reorders (childList),
    // both of which Dawn performs on a variant change.
    new MutationObserver(sync).observe(viewer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    // Initial + timing-safe runs: now, after the next frame (custom-element upgrade /
    // layout settle), and after full load (late-decoding images).
    sync();
    if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
    window.addEventListener('load', sync, { once: true });

    // Belt-and-suspenders: Dawn publishes variantChange after its AJAX fetch resolves;
    // re-assert the ring then in case a DOM mutation slipped past the observer.
    // NOTE: PUB_SUB_EVENTS is declared with `const` in constants.js, so it is a global
    // lexical binding — NOT a property of `window`. Reference it bare (guarded by typeof)
    // rather than via window.* (which is always undefined and silently skipped this block).
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
          else sync();
        });
      }
    } catch (e) {
      /* pub/sub not available — observer + load handlers still cover the cases */
    }
  }

  /* ----- top rating → smooth-scroll to the reviews section ----- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to-reviews]');
    if (!trigger) return;
    var target = document.getElementById('pdp-reviews');
    if (!target) return; // no reviews section on page → anchor just does nothing
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.pdp-acc__item').forEach(setupAccordion);
    root.querySelectorAll('product-info').forEach(setupMediaSync);
    root.querySelectorAll('media-gallery').forEach(setupThumbSync);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
